import SwatchHelper from "./SwatchHelper";

export const executeClickAfterEnterKeyupForSwatchElementOnPdp = () => {
    /** TODO
     * VSK has an issue where both the click event and the enter event on a swatch element trigger the same effect on the Product Detail Page (PDP).
     * This method should either be removed if VSK has fixed the issue, or implemented if the issue has not yet been resolved.
     */
};

export const changeSwatchesRoleToPresentationInPLP = () => {
    let swatchHelper = new SwatchHelper(".c-grid__meta");
    swatchHelper.onSwatchRendered((node, searchedNode) => {
        /**
         * I'm making this change because the swatch is inside the link, and as a result,
         * the screen reader does not recognize it as a radio group, making it impossible to select a single color
         */
        searchedNode.setAttribute("role", "presentation");
    });
};
